import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
// import common components
import Loader from "../../components/common/Loader";
import {  Form } from "react-bootstrap";
import {
  getOpportunitiesEligibilties,
  postOpportunitiesEligibilties,
} from "../../services/opportunityService";
// import dummies
import { USER } from "../../helpers/dummies";
import { ELIGIBILTY_ANSWER } from "../../helpers/constants";
// import router
import { Link, withRouter, useLocation, useHistory } from "react-router-dom";
// import components

import { useSelector, useDispatch } from "react-redux";
import CommonIcon from "../../components/common/CommonIcon";

export default function OpportunityVerification() {
  const history = useHistory();
  const location = useLocation();
  const { state } = location;
  const [question, setQuestion] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [answer, setAnswer] = useState({});
  const [eligibityAnswer, setEligibityAnswer] = useState([]);
  const [areAllFieldSelected, setAreALLFieldSelected] = useState([]);
  const [mandatoryFields,setMandatoryFields]=useState(false);
  const [selectedValue, setSelectedValue] = useState({});

  useEffect(() => {
    let code = state.code;

    getOpportunitiesEligibilties(code)
      .then((res) => {
         if(res?.opportunities?.length)
         {
        setQuestion(res?.opportunities);
         }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleSelectChange = (e, index) => {
    const newSelectedOptions = [...selectedOptions];
    newSelectedOptions[index] = e.target.value;
    setSelectedOptions(newSelectedOptions);
  };

  const handleOnSubmited = (e) => {
    e.preventDefault();
    // console.log({ state });
    if (question?.length !== eligibityAnswer?.length) {
      //  console.log("length",question?.length , eligibityAnswer?.length)
       setMandatoryFields(true);
    }
    else{
    postOpportunitiesEligibilties(eligibityAnswer)
      .then((res) => {
        if (res.eligible === true) {
          history.push(`/opportunites/${state.formationName}`, state);
        } else if (res.eligible === false) {
          // console.log(res);
          setAreALLFieldSelected(res.eligibilities_failed);
          // history.push(`/opportunites`);
        } else if (res.error) {
          console.log(res);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    }

    // console.log(eligibityAnswer);
    // setTimeout(()=>{
    //   setMandatoryFields(false)
    // },2000)
    // Handle form submission for the specific question
  };

  const selectMandatoryFieldsValue = (e,questionId) => {
    if (e.target) {
      // console.log(e.target);
      let { name, value } = e.target;
      // console.log("target", { name, value });
      setSelectedValue({
        ...selectedValue,
        [questionId]: e.target.value,
      });
      // setAnswer((prev)=>({...prev,id:name,[name]:value}));
      let data = {
        question_id: name,
        answer: value,
    };
    
    let found = false;
    
    eligibityAnswer.forEach((ele, index) => {
        if (ele.question_id === data.question_id) {
            // console.log(ele.answer, data.answer);
            eligibityAnswer[index].answer = data.answer;
            found = true;
        }
    });
    
    if (!found) {
        eligibityAnswer.push(data);
    }
    
    // console.log("eligibityAnswer", eligibityAnswer);
    
    //   let data = {
    //     question_id: name,
    //     answer: value,
    //   };
     
    //   if(eligibityAnswer.length > 0)
    //   {
    //   eligibityAnswer.map((ele,index)=>{
    //     console.log(ele.question_id===data.question_id)
    //       if(ele.question_id===data.question_id)
    //       {
    //         console.log(ele.answer,data.answer)
    //         eligibityAnswer[index].answer=data.answer
    //         return 
    //       }
    //       else{
    //         console.log({data})
    //         eligibityAnswer.push(data)
    //       }
    //   })
    //   //console.log(eligibityAnswer)
    // }
      
    //   else{
    //   eligibityAnswer.push(data);
    //   }
      // console.log("ele",eligibityAnswer)
      setAnswer((prev) => ({ ...prev, id: name, answer: value }));
    }
  };

  const cancelMandatoryFields = (e) => {
    e.preventDefault();
    setAnswer({});
    setEligibityAnswer([]);
    setAreALLFieldSelected([]);
    setSelectedValue({});
   
  };



  return (
    <React.Fragment>
      <div className="container pt-16">
        <div className="flex justify-between mb-3 mt-2">
          <Breadcrumbs
            subtitle="opportunites"
            subtitleLink="/opportunites"
            // extratitle="opportunites"
            // extratitleLink="/"
            currentTile="admissibilité"
          />
          <CommonIcon />
        </div>
        <div className="row">
          <div className="col-lg-6 offset-lg-3 pt-5">
            <center>
              <small className="text-muted text-center">
                Remplissez le formulaire ci-dessous pour être éligible à
                l'opportunité
              </small>
            </center>
          </div>
          <div className="col-lg-6 offset-lg-3">
            <Form
              // onSubmit={this.onSubmited}
              className="auth-form"
            >
              <div className="text-muted mb-2">
                Vos informations personnelles
              </div>

              <div className="row">
              {mandatoryFields && <div className='text-danger fw-bold'>All the fields are required.</div>}
                {question && question.length > 0 ? (
                  question.map((data, index) => (
                    <div className="col-lg-12" key={index}>
                      <Form.Group className="mb-3">
                        <Form.Label>{data.question}</Form.Label>
                        <Form.Control
                          as="select"
                          required
                          custom
                          onChange={(e) => selectMandatoryFieldsValue(e,data.id)}
                          name={data.id}
                          value={selectedValue[data.id] || ''}
                         
                        >
                          {ELIGIBILTY_ANSWER &&
                            ELIGIBILTY_ANSWER.length > 0 &&
                            ELIGIBILTY_ANSWER?.map((country) => (
                              <option key={country.id} value={country.name}>
                                {country.name}
                              </option>
                            ))}
                        </Form.Control>
                        {areAllFieldSelected &&
                          areAllFieldSelected?.length > 0 &&
                          areAllFieldSelected?.map((ele) =>
                            data.id === ele.id ? (
                              <p
                                key={ele.id}
                                style={{
                                  color: "red",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                  marginTop: "5px",
                                }}
                              >
                                !Not Eligible
                              </p>
                            ) : null
                          )}
                      </Form.Group>
                    </div>
                  ))
                ) : (
                  <></>
                )}
                <div className="flex justify-between mt-4">
                  <button
                    type="button"
                    className="btn-discover btn btn-primary"
                    onClick={cancelMandatoryFields}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn-discover btn btn-primary"
                    onClick={handleOnSubmited}
                  >
                    Submit
                  </button>
                </div>
              </div>

             

              {/* {failure !== "" ? (
                  <div className="alert alert-danger" role="alert">
                    {failure}
                  </div>
                ) : null}

                {success ? (
                  <div
                    className="alert alert-success alert-dismissible fade show"
                    role="alert"
                  >
                    Votre candidature a bien été envoyée.
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="alert"
                      aria-label="Close"
                    />
                  </div>
                ) : null}

                {loading ? (
                  <Loader color="blue" />
                ) : (
                  <button className="btn-discover" type="submit">
                    Envoyer
                  </button>
                )} */}
            </Form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
